import React, {useEffect, useState} from "react";
import Header from "../../components/Header.js";
import {FormattedMessage, FormattedNumber, IntlProvider} from 'react-intl';
import * as StorageService from "../../services/StorageService.js";
import {
    DEFAULT_TIP_VALUES,
    FIREBASE_SCREEN_NAMES,
    HEADER_SIZE,
    LOCALSTORAGE_ITEMS,
    PAYMENT_TYPES,
    USER_TYPES
} from "../../util/Constants.js";
import OrderSummActionsBar from "../../components/Actionsbar/OrderSummActionsBar.js";
import * as ProductService from "../../services/ProductService";
import {EventBus} from "../../util/EventBus";
import {clearStorageItems, getAppLocale, getLastDay, getOrderCheckoutMsg, getTotalProducts} from "../../util/common";
import Spinner from "../../components/Spinner";
import {renderProducts} from "../../util/common.js";
import {PATH} from "../../routes/routes.js";
import analyticsLogEvent from "../../services/FirebaseService";
import penIcon from "../../assets/img/icon_pen.svg";
import smileyNeutralIcon from "../../assets/img/icon_smiley_neutral.svg";
import smileySmileIcon from "../../assets/img/icon_smiley_smile.svg";
import smileyLoveIcon from "../../assets/img/icon_smiley_love.svg";
import currencies from "currency-codes";
import * as PaymentHandler from "../../handlers/HandlerPayment";
import {useLocation, useNavigate} from "react-router";

function TablePayment() {
    const navigateTo = useNavigate();
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const paymentStatus = query.get('status');
    const userTable = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) : null;
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const allowedPaymentMethods =  shopDetails?.merchantConfig?.pmtMethodsForTable;
    const showDownloadApp = shopDetails ? (typeof shopDetails.merchantConfig.showDownloadApp !== "undefined" ? shopDetails.merchantConfig.showDownloadApp : null) : false;
    const isBarPickup = shopDetails ? (typeof shopDetails.merchantConfig.barPickup !== "undefined" ? shopDetails.merchantConfig.barPickup : null) : false;
    const userType = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) : null;
    const currency = shopDetails ? shopDetails.currency : null;
    const hasTips = shopDetails ? shopDetails.merchantConfig.hasTips : null;

    const visible = "visible";
    const hidden = "hidden";

    const [state, setState] = useState({
        errors: null,
        loading: false,
        isSubmitBtnEnabled: true,
        tipValueFinal: 0,
        tipValueTemporary: "",
        selectedTipPercentage: null,
        errorMsg: null,
        tipValueModalStyle: hidden,
        cashOrCardModalStyle: hidden,
        allOrderProducts: StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS)) : null,
        selectedPaymentType: PAYMENT_TYPES.WAITER,
        paymentLink:null
    });

    const PAYMENT_STATUSES = {
        PENDING: "pending",
        FAILED: "failed"
    }

    useEffect(() => {
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.PAYMENT,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.PAYMENT
        });
    }, []);

    useEffect(() => {

        if (paymentStatus === PAYMENT_STATUSES.PENDING) {
            let delayDebounceFn = null;
            delayDebounceFn = setTimeout(() => {
                checkIfOrderWasChanged();
            }, 3000)
            return () => clearTimeout(delayDebounceFn);
        }
    }, [state]);

    let buttonClicked = false;

    const setPaymentType = (type) => {
        setState({
            ...state,
            selectedPaymentType: type,
            errorMsg: null
        })
    }

    const showWaiterClosedTheOrderPopup = () => {
        EventBus.dispatch("waiterClosedTheOrder");
    }

    const openTipValuePopup = () => {
        setState({
            ...state,
            tipValueModalStyle: visible,
            errors: false,
        })
    }

    const closeTipValueModal = () => {
        setState({
            ...state,
            tipValueTemporary: "",
            tipValueModalStyle: hidden,
            errors: false,
        })
    }



    const openCashOrCardPopup = () => {
        setState({
            ...state,
            cashOrCardModalStyle: visible
        })
    }
    const closeCashOrCardPopup = () => {
        setState({
            ...state,
            cashOrCardModalStyle: hidden,
        })
    }

    const clearOrderIdAndGoToHomepage = () => {
        clearStorageItems();
        navigateTo(PATH.ALL_PRODUCTS);
    }

    const handleCashButton = () => {
        if (buttonClicked) {
            return;
        }
        buttonClicked = true;
        closeCashOrCardPopup();
        checkoutProductsOrder(PAYMENT_TYPES.CASH).then(() => {

            navigateTo(PATH.THANK_YOU + "/" + StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID));
            buttonClicked = false;
        });
    }

    const handleCardButton = () => {
        if (buttonClicked) {
            return;
        }
        buttonClicked = true;
        closeCashOrCardPopup();
        checkoutProductsOrder(PAYMENT_TYPES.CARD).then(() => {
            navigateTo(PATH.THANK_YOU + "/" + StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID));
            buttonClicked = false;
        });
    }

    const setSelectedTipPercentage = (selectedTipPercentage) => {
        setState({
            ...state,
            selectedTipPercentage: state.selectedTipPercentage === null || state.selectedTipPercentage !== selectedTipPercentage ? selectedTipPercentage : null,
            tipValueFinal: state.selectedTipPercentage !== selectedTipPercentage ? (selectedTipPercentage / 100 * (state.allOrderProducts.price / 100.0)).toFixed(2) : 0,
            tipValueTemporary: state.selectedTipPercentage !== selectedTipPercentage ? (selectedTipPercentage / 100 * (state.allOrderProducts.price / 100.0)).toFixed(2) : 0
        })
    }


    const setTipValueTemporary = (value) => {
        setState({
            ...state,
            tipValueTemporary: value
        })
    }

    const setTipValue = (value) => {
        if (value === null || value === "" || !value.replace(/\s/g, '').length) {
            setState({
                ...state,
                errors: <FormattedMessage id="TipsValidation"/>
            })
        } else if (!/^\d+(\.\d{0,2})?$/.test(value)) {
            setState({
                ...state,
                errors: <FormattedMessage id="TipsValidation"/>
            })
        } else {
            setState({
                ...state,
                tipValueFinal: value !== "" ? value : 0,
                tipValueModalStyle: hidden,
                errors: false,
                selectedTipPercentage: null
            })
        }
    }


    const checkIfProductsWereChanged = (cachedProducts, newProducts) => {

        if (cachedProducts.length !== newProducts.length) {
            return false;
        }
        for (let i = 0; i < cachedProducts.length; i++) {
            const cachedProduct = {
                ...cachedProducts[i]
            };
            const newProduct = newProducts[i];
            if (newProduct.status === "DELIVERED") {
                cachedProduct.status = "DELIVERED";
            }
            if (JSON.stringify(cachedProduct) !== JSON.stringify(newProduct)) {

                return false;
            }
        }

        return true;
    }




    const checkIfOrderWasChanged = async () => {
        if (state.loading) {
            return;
        }
        setState({
            ...state,
            loading: true
        })


        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "fromDate": getLastDay(),
            // "procStatus": ["OPEN", "CONFIRMED", "READY", "DELIVERED"]
        }

        const response = await ProductService.getAllProductsOrders(body);
        if (response.ok) {
            let currentOrder = null;
            const storageCurrentOrderId = StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID);
            for (let i = 0; i < response.data.orders.length; i++) {
                const o = response.data.orders[i];
                if (o.oid === storageCurrentOrderId) {
                    currentOrder = o;
                    break;
                }
                if (currentOrder === null && o.procStatus === "OPEN") {
                    currentOrder = o;
                }
            }

            if (currentOrder.lastMod !== state.allOrderProducts.lastMod && currentOrder.procStatus !== "DELIVERED" &&
                !checkIfProductsWereChanged(state.allOrderProducts.products, currentOrder.products)) {
                setState({
                    ...state,
                    errorMsg: <FormattedMessage id="YourOrderWasModified"/>,
                    allOrderProducts: currentOrder
                })
                StorageService.setItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS, JSON.stringify(currentOrder));
                return true
            } else {
                if (currentOrder.onlinePmtPlatform && currentOrder.onlinePmtPlatform === "STRIPE" && currentOrder.paymentStatus === "COMPLETE"  ) {
                    navigateTo(PATH.THANK_YOU + "/" + StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID));
                }

                return false;
            }
        }
    }

    const changeOrder = async () => {
        const currency = currencies.code(shopDetails.currency);

        const body = {

            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "oid": StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID),
            "place": "TABLE",
            "table": userTable,
            "tips": Math.round(state.tipValueFinal * Math.pow(10, currency.digits))
        }

        const response = await ProductService.changeProductsOrder(body);

        return response;
    }

    const checkoutProductsOrder = async (chosenPaymentMethod) => {

        if (!state.isSubmitBtnEnabled) {
            return;
        }
        setState({
            ...state,
            isSubmitBtnEnabled: false,
            loading: true,
        })

        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "oid": StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID),
            "paymentMethod": chosenPaymentMethod || null
        }

        if (hasTips && state.tipValueFinal !== 0) {
            const changeOrderResponse = await changeOrder();
            if (!changeOrderResponse.ok) return;
        }

        const response = await ProductService.checkoutProductsOrder(body);
        if (response.ok) {
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                loading: false,
            })
        } else {
            if (response.data.code === 500) {
                if (response.data.internalCode === "23") {
                    setState({
                        ...state,
                        isSubmitBtnEnabled: true,
                        loading: false,
                    })

                    navigateTo(PATH.THANK_YOU + "/" + StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID));
                } else {
                    setState({
                        ...state,
                        errorMsg: <FormattedMessage id="YourOrderWasClosed"/>,
                        loading: false
                    })
                    closeCashOrCardPopup();
                    showWaiterClosedTheOrderPopup();
                }

            } else {
                setState({
                    ...state,
                    errorMsg: <FormattedMessage id="SomethingWentWrong"/>,
                    loading: false
                })
            }
        }
    }

    if (state.allOrderProducts == null && !isBarPickup) {
        navigateTo(PATH.ALL_PRODUCTS)
        return null;
    }


    const initializeStripePayment = (stripeConfig) => {
        PaymentHandler.createProductsOrderStripePaymentLinkHandler(stripeConfig).then(response => {
            if (response.data.error === null) {
                window.location.href = response.data.paymentLink;
            }else{
                setState({
                    ...state,
                    errorMsg: response.data.error
                })
            }
        })
    }

    const handleSubmit = () => {
        if (!state.isSubmitBtnEnabled || paymentStatus === PAYMENT_STATUSES.PENDING) {
            return
        }
        setState({
            ...state,
            isSubmitBtnEnabled: false,
            loading: true,
        })
        checkIfOrderWasChanged().then(r => {

            if (!r) {
                if (state.selectedPaymentType === PAYMENT_TYPES.WAITER) {
                    openCashOrCardPopup();
                } else if (state.selectedPaymentType === PAYMENT_TYPES.ONLINE) {
                    const currentUrl = window.location.href;
                    let stripeConfig = {
                        shop: StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
                        user: StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
                        oid: StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID),
                        successUrl: currentUrl.split("?")[0] + "?status=pending",
                        cancelUrl: currentUrl.split("?")[0] + "?status=failed"
                    }

                    if (hasTips && state.tipValueFinal !== 0) {
                       changeOrder().then(changeOrderResponse => {

                            if (!changeOrderResponse.ok) return;

                            initializeStripePayment(stripeConfig);
                        });                        
                    }else {
                        initializeStripePayment(stripeConfig);
                    }
                    
                }
            }
        });
    }


    const showNoAccountPopup = () => {
        EventBus.dispatch("accessingOnlyLoggedUsersFeature");
    }


    return (
        <>
            <Header
                headerSize={HEADER_SIZE.SMALL}
                headerTitle={<FormattedMessage id="Payment"/>}
                hasBackBtn={true}
                hasModal={true}
            />

            <main className={"page-content table-payment-page-content" + (paymentStatus === PAYMENT_STATUSES.PENDING ? " disabled" : "")} data-qa="table-payment-page-content">
                <div className={state.tipValueModalStyle + " modal-overlay "}
                     onClick={(e) => closeTipValueModal()}></div>
                <div className="modal bigger left-aligned-text">
                    <div className="row">
                        <div className="modal-title">
                            <FormattedMessage id="AddTipInSelectedCurrencyParam"
                                              values={{selectedCurrencyParam: currency}}/>
                        </div>
                    </div>
                    <div className="modal-content">
                        <div className="basic-form">
                            <div className="row">
                                <input data-qa="payment-custom-tip-input"
                                       onChange={(e) => setTipValueTemporary(e.target.value)} type="number"
                                       placeholder={"5.50"} value={state.tipValueTemporary}/>
                            </div>
                            <div className="row errors-no-bg">
                                {state.errors}
                            </div>
                        </div>
                    </div>

                    <div className="row buttons-row">
                        <a className="btn btn-md" id="CANCEL" onClick={() => closeTipValueModal()}><FormattedMessage
                            id="Cancel"/></a>
                        <a className="btn btn-special btn-md" id="CONFIRM"
                           onClick={() => setTipValue(state.tipValueTemporary)}><FormattedMessage id="Confirm"/></a>
                    </div>
                </div>

                {/*START CASH OR CARD MODAL*/}
                <div className={state.cashOrCardModalStyle + " modal-overlay "}
                     onClick={(e) => closeCashOrCardPopup()}></div>
                <div className="modal">
                    <div className="row">
                        <div className="modal-title"><FormattedMessage id="ChoosePaymentMethod"/></div>
                    </div>

                    <div className="row buttons-row">
                        { allowedPaymentMethods?.includes(PAYMENT_TYPES.CASH) &&   <a className=" btn btn-outlined btn-md" id="CASH" onClick={handleCashButton}
                           data-qa="payment-cash-btn"><FormattedMessage id="Cash"/></a>}
                        {allowedPaymentMethods?.includes(PAYMENT_TYPES.CARD) &&
                        <a className="btn btn-outlined btn-md" id="CARD" onClick={handleCardButton}data-qa="payment-card-btn"><FormattedMessage id="Card"/></a>
                        }

                    </div>
                </div>
                {/*END CASH OR CARD MODAL*/}


                {/*START TABS CONTAINER*/}
                <section className="tabs-container">
                    {(showDownloadApp === true || showDownloadApp === null) && <>
                        <div className="tabs-container-title">
                            <FormattedMessage id="ChoosePaymentMethod"/>
                        </div>
                        <div className="row tabs-row">

                            {allowedPaymentMethods?.includes(PAYMENT_TYPES.ONLINE) &&
                                <>
                                    {(userType === USER_TYPES.ANONYMOUS || userType === null) ?
                                        <a className="tab-link disabled" data-qa="payment-online-btn"
                                           onClick={showNoAccountPopup}>
                                            <FormattedMessage id="Online"/>
                                        </a>
                                        :
                                        <a className={state.selectedPaymentType === PAYMENT_TYPES.ONLINE ? "tab-link active" : "tab-link"}
                                           data-qa="payment-online-btn" onClick={() => setPaymentType(PAYMENT_TYPES.ONLINE)}>
                                            <FormattedMessage id="Online"/>
                                        </a>
                                    }
                            </>

                            }



                            <a className={state.selectedPaymentType === PAYMENT_TYPES.WAITER ? "tab-link active" : "tab-link"}
                               data-qa="payment-waiter-btn" onClick={() => setPaymentType(PAYMENT_TYPES.WAITER)}>
                                <FormattedMessage id="Waiter"/>
                            </a>
                        </div>




                    </>}

                    {hasTips &&
                    <div className="tips-container">
                        <div className="row info-row tip-label-and-value">
                            <div className="col label">
                                <FormattedMessage id="Tip"/>
                            </div>
                            <div onClick={() => openTipValuePopup()} className="col value ml-auto"
                                 data-qa="payment-open-custom-tip-popup">
                               <span className="label-value">
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={state.tipValueFinal}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                               </span>
                                <span className="icon"><img height="18" src={penIcon}/>
                                </span>
                            </div>
                        </div>

                        <div className="row default-tips" data-qa="table-payment-tips">
                            <div
                                onClick={() => setSelectedTipPercentage(DEFAULT_TIP_VALUES.GOOD)}
                                className={("col default-tip-col faded ") + (state.selectedTipPercentage === DEFAULT_TIP_VALUES.GOOD ? "active" : "")}
                                data-qa="table-payment-tip-5" data-qa-tip-value="5%">
                                <div className="tip-amount">{DEFAULT_TIP_VALUES.GOOD}%</div>
                                <div className="tip-icon"><img src={smileyNeutralIcon}/></div>
                                <div className="tip-label"><FormattedMessage id="GoodService"/></div>
                            </div>

                            <div
                                onClick={() => setSelectedTipPercentage(DEFAULT_TIP_VALUES.GREAT)}
                                className={("col default-tip-col orange ") + (state.selectedTipPercentage === DEFAULT_TIP_VALUES.GREAT ? "active" : "")}
                                data-qa="table-payment-tip-10" data-qa-tip-value="10%">
                                <div className="tip-amount">{DEFAULT_TIP_VALUES.GREAT}%</div>
                                <div className="tip-icon"><img src={smileySmileIcon}/></div>
                                <div className="tip-label"><FormattedMessage id="GreatService"/></div>
                            </div>

                            <div
                                onClick={() => setSelectedTipPercentage(DEFAULT_TIP_VALUES.EXCELLENT)}
                                className={("col default-tip-col danger ") + (state.selectedTipPercentage === DEFAULT_TIP_VALUES.EXCELLENT ? "active" : "")}
                                data-qa="table-payment-tip-15" data-qa-tip-value="15%">
                                <div className="tip-amount">{DEFAULT_TIP_VALUES.EXCELLENT}%</div>
                                <div className="tip-icon"><img src={smileyLoveIcon}/></div>
                                <div className="tip-label"><FormattedMessage id="ExcellentService"/></div>
                            </div>
                        </div>
                    </div>}

                    <div className="row info-row">
                        {getOrderCheckoutMsg()}
                    </div>
                    <div className="order-details-top-msg ml-0">
                        <div className="row">
                            <FormattedMessage id="OrderNumber"/>&nbsp;
                            <span className="order-number">#{StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID)}</span>
                        </div>

                    </div>
                </section>
                {/*END TABS CONTAINER*/}


                <section className="order-details-card">
                    <header className="order-details-card-header neutral">
                        <FormattedMessage id="OrderDetails"/>
                    </header>
                    <div className="card-content">
                        {
                            renderProducts(state.allOrderProducts)
                        }

                        {state.tipValueFinal !== 0 && state.tipValueFinal !== "0" &&
                        <div className="subtotal-and-discount-container">
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                  <FormattedMessage id="Subtotal"/>
                                </span>
                                <span className="total-price" data-qa="subtotal-and-discount-container">
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={state.allOrderProducts.price / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                    <FormattedMessage id="Tip"/>
                                </span>
                                <span className="total-price" data-qa="payment-tips-value"
                                      data-qa-value={state.tipValueFinal}> + &nbsp;
                                    <IntlProvider locale={getAppLocale()}>
                                        <FormattedNumber
                                            value={state.tipValueFinal}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>
                        </div>
                        }

                        <div className="total-container row">
                            <span className="total-prod-nr">{
                                getTotalProducts(state.allOrderProducts.products)
                            }&nbsp;</span>
                            <span
                                className="total-prod-label">{getTotalProducts(state.allOrderProducts.products) !== 1 ?
                                <FormattedMessage id="Products"/> : <FormattedMessage id="Product"/>}</span>
                            <span className="total-price" data-qa="payment-total-price">

                                 <IntlProvider locale={getAppLocale()}>
                                 <FormattedNumber
                                     value={state.tipValueFinal != 0 && state.tipValueFinal !== "0" ? state.allOrderProducts.price / 100.0 + +state.tipValueFinal : state.allOrderProducts.price / 100.0}
                                     style="currency"
                                     minimumFractionDigits={2}
                                     maximumFractionDigits={2}
                                     currency={currency}/>
                                 </IntlProvider>
                            </span>
                        </div>

                    </div>
                </section>
                {paymentStatus === PAYMENT_STATUSES.PENDING &&
                    <div className="row centered-content dot-container"><span><FormattedMessage id="PaymentPending"/></span><span className="dots dot-blink"></span></div>
                }
                {state.errorMsg != null ?
                    <div className="error-div">
                        <p>&#9888;&nbsp;{state.errorMsg}</p>
                        {state.errorMsg === <FormattedMessage id="YourOrderWasClosed"/> ?
                            <a className="btn btn-special" onClick={clearOrderIdAndGoToHomepage}><FormattedMessage
                                id="GoToHomePage"/></a>
                            : null}
                    </div>
                    : null
                }
            </main>
            <OrderSummActionsBar
                isVisible={true}
                buttonName={<FormattedMessage id="FinishOrder"/>}
                dataQAIdentifier1="table-payment-submit-btn"
                btnClassName={(state.isSubmitBtnEnabled && paymentStatus !== PAYMENT_STATUSES.PENDING)  ? "btn btn-default btn-xl" : "btn btn-default btn-xl btn-disabled"}
                buttonAction={() => {
                    state.isSubmitBtnEnabled ? handleSubmit() : void (0);
                }}
            />

            {state.loading ?
                <div className="spinner" data-qa="spinner"><Spinner/></div>
                : null
            }
        </>
    );
}

export default TablePayment;
